/**
 * Типы иконок для преимуществ ШЦР
 */
export enum EMainPageAdvantageIcons {
  Case = 'case',
  Medal = 'medal',
  Message = 'message',
  Server = 'server',
  Study = 'study',
  TrendingUp = 'trending_up',
  User = 'user',
}
